import React, { useState } from "react";
import { Modal, Form, Input, message, notification } from "antd";
import { api } from "../../helpers/ApiHelper";
import strings from "../../utils/Localization";
import { useDispatch } from "react-redux";
import { setRerender } from "../../redux/actions/rerenderAction";

const formSize = "middle";

function CariGrupEkleModal({ visible = false, handleCancel }) {
  const [fetchLoading, setFetchLoading] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { cariGrupEkleModal: localization } = strings.cariGrup;

  const onFinish = async (values) => {
    try {
      setFetchLoading(true);
      const { ad } = values;
      const response = await api.post("/carigrup", {
        Ad: ad,
      });

      if (response.status === 200) {
        notification["success"]({
          message: strings.mesaj.basarliBaslik,
          description: strings.mesaj.islemBasarili,
        });
        form.resetFields();
        dispatch(setRerender());
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setFetchLoading(false);
    }
  };

  return (
    <Modal
      title={localization.baslik}
      visible={visible}
      onCancel={handleCancel}
      handleCancel={handleCancel}
      okButtonProps={{
        htmlType: "submit",
        form: "cariGrupEkleModal",
        size: formSize,
        loading: fetchLoading,
      }}
      cancelButtonProps={{ size: formSize }}
    >
      <Form
        name="cariGrupEkleModal"
        form={form}
        onFinish={onFinish}
        layout="vertical"
        size={formSize}
      >
        <Form.Item
          name="ad"
          label={localization.cariGrupAdi}
          rules={[{ required: true }]}
        >
          <Input placeholder={localization.cariGrupAdiPlaceHolder} />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default CariGrupEkleModal;
